module.exports = __webpack_public_path__ + "img/overview.88107c42.svg";